import React, { Component } from 'react';
import _ from 'lodash';
import Link from '../../../../../components/ZUILib/Link';
import InputButton from '../../../../../components/ZUILib/InputButton';
import ApplyCSS from '../../../../../components/ApplyCSS';
import VerificationPanel from './verificationPanel';
import commonUtil from '../../../../../utils/commonUtil';
// import { constDownload } from '../../../../../utils/clientConstant';
import ClosingGiftPanel from './ClosingGiftPanel';

const pageName = 'closureTransference';
const channel = commonUtil.getChannel();
const brand = commonUtil.getBrand();
const constChannels = commonUtil.getClientConstForChannel();


export default class ClosureConfirmationRender extends Component {

  render() {
    const Guardar = {
      name: 'Guardar',
      type: 'button',
      value: 'Guardar',
      autoFocus: false,
      style: 'btnPrimaryAction size-Small',
      onClickHandler: this.props.saveCard,
      id: 'save',
      disabled: this.props.isGuardar,
    };
    const eventAdministrationRedirectLink = {
      text: 'Ir a mesa de regalos',
      children: 'Ir a Mesa de Regalos',
      href: '',
      cssClass: 'btnPrimary size-Full giftListRedirectLink',
      cssStyle: {
        borderRadius: '4px',
      },
      onClickHandler: this.props.redirectToAdministration,
    };
    const eventAdministrationRedirect = {
      name: 'Ir a mesa de regalos',
      type: 'button',
      value: 'Ir a Mesa de Regalos',
      autoFocus: false,
      style: 'btnPrimary size-Large',
      onClickHandler: this.props.redirectToAdministration,
      id: 'eventAdministrationRedirect',
    };
    const downloadFile = {
      route: '',
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.props.emailSendClick(); },
    };
    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ eWalletCreatedMessage: null, savedCardConfirmation: null }); },
    };

    return (
      <div className="toPrint">
        {!_.isEmpty(this.props.submitData) && !_.isEmpty(this.props.lables) ?
          <React.Fragment>
            {channel === constChannels.WAP ?
              <React.Fragment>
                <ApplyCSS pageName={pageName + 'WAP'} />
                <div className="row" style={{ backgroundColor: '#FFFFFF' }}>
                  <div className="col-xs-12 innerSteps closeSteps">
                    <p style={{ textAlign: 'center', marginTop: '10px' }}>
                      <span
                        style={{
                          fontSize: '20px',
                          fontWeight: '400',
                          color: '#333333',
                        }}
                      >
                        {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.success.message')}
                        </span>
                    </p>
                    <div className="col-xs-12 col-md-12"><img src={this.props.getBrandLogoPath(brand)} /></div>
                  </div>

                  {!_.isEmpty(this.props.submitData.monederoAccountInfo) || !_.isEmpty(this.props.submitData.bankOrCardInfo) ?
                    <React.Fragment>
                      {this.props.eWalletCreatedMessage ? <div className="alertSuccess"><i className="icon-check" />
                        <p>{this.props.eWalletCreatedMessage ? this.props.eWalletCreatedMessage : null} </p>
                        <Link linkJSON={errorAncher} /></div> : null}
                      <div className="col-xs-12 innerOptions">
                        <p
                          style={{
                            fontSize: '20px',
                            fontWeight: '400',
                            color: '#333333',
                            textAlign: 'center',
                            padding: '2rem 0',
                          }}
                        >
                          {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.closureConfirmation.title')}
                        </p>
                        {this.props.submitTransferenceData &&
                          <React.Fragment>
                            <p>
                              <span style={{ color: '#333333' }}>Fecha de operación &nbsp;</span>
                              {commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}
                            </p>
                          </React.Fragment>}
                      </div>
                      <VerificationPanel
                        submitTransferenceData={this.props.submitTransferenceData}
                        loadFrom="closureConfirmation" user={this.props.user}
                        isEmployee={this.props.isEmployee}
                      />
                      {this.props.emailSendStatus ?
                        <div className="col-xs-12 mb10">
                          {this.props.emailSendStatus.isSent ?
                            <div className="alertSuccess" > <i className="icon-check" />
                              <p>{this.props.emailSendStatus.resMsg}</p>
                              <Link linkJSON={emailSendLink} />
                            </div> :
                            <div className="alertError" > <i className="icon-tache2" />
                              <p>{this.props.emailSendStatus.resMsg}</p>
                              <Link linkJSON={emailSendLink} />
                            </div>}
                        </div> : null}
                      <div className="col-xs-12 innerCaptions">
                        <p>
                          {(this.props.submitTransferenceData && this.props.submitTransferenceData.walletType !== 'undefined' && this.props.submitTransferenceData.walletType == 'Monedero Digital') &&
                          <React.Fragment><br />{commonUtil.getLabel(this.props.lables['transference success page'], 'email.dwallet.giftClosingInfo.transferInfo1')}</React.Fragment>
                        }</p>
                        <p style={{ textAlign: 'left' }}>
                          <span>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label5')}</span>
                           &nbsp;
                          <span><strong>{this.props.submitData.emailAddress},</strong>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label2')}</span>
                        </p>
                        <p style={{ textAlign: 'left' }}>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label3')}
                          <strong>
                            {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label4')}
                          </strong>
                        </p>
                      </div>

                      <div className="col-xs-12 mb10">
                        {this.props.submitData && this.props.submitData.enableSaveButton && this.props.submitData.enableSaveButton.toString() === 'true' ?
                          <div>
                            <p className="mainText">{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.closureConfirmation.savemessage')}</p>
                            <InputButton buttonAttr={Guardar} />
                          </div> : null}
                      </div>
                    </React.Fragment> : null}

                  {!_.isEmpty(this.props.submitData.closingGiftDetails) ?
                    <ClosingGiftPanel submitTransferenceData={this.props.submitTransferenceData} bridgeCoreRequest={!this.props.printAndDownload ? this.props.submitData.bridgeCoreRequest : null} eventID={this.props.eventID} lables={this.props.lables} loadFrom="closureConfirmation" />
                    : null}
                  {!this.props.printAndDownload ?
                    <div className="col-xs-12 mb10">
                      <Link linkJSON={eventAdministrationRedirectLink}>Ir a Mesa de Regalos</Link>
                    </div> : null}
                </div>
              </React.Fragment>
              : <div className="container">
                <div className="box-shadow-wrapper" id="partialConfirmation" style={{ backgroundColor: '#FFFFFF' }}>
                  <ApplyCSS pageName={pageName} />
                  <div className="row">
                    <div className="col-xs-9 col-md-7">
                      <div className="box-name">
                        <span className="subtitle" style={{ color: '#333333' }}>
                          ¡{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.success.message')}!
                        </span>
                      </div>
                    </div>
                    <div className="col-xs-3 col-md-5 text-right"><img src={this.props.getBrandLogoPath(brand)} /></div>
                  </div>
                  <div className="row step3">
                    <div className="col-md-12 col-sm-12">

                      {!_.isEmpty(this.props.submitData.monederoAccountInfo) || !_.isEmpty(this.props.submitData.bankOrCardInfo) ?
                        <React.Fragment>
                          {/* eslint-disable */
                            this.props.eWalletCreatedMessage || this.props.savedCardConfirmation ? <div className="alertSuccess"><i className="icon-check" />
                              <p>{this.props.eWalletCreatedMessage ? this.props.eWalletCreatedMessage : this.props.savedCardConfirmation ? this.props.savedCardConfirmation : null}</p>
                              <Link linkJSON={errorAncher} />
                            </div> : null
                            /* eslint-enable */
                          }
                          <div className="row">
                            <div className="col-md-6 col-sm-6">
                              <span className="title-confirmation">
                                {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.closureConfirmation.title')}
                              </span>
                            </div>
                            <div className="col-md-6 col-sm-6">
                              <div className="box-icons text-right">
                                <Link rrLink={downloadFile} >
                                  <i className="iClass icon-descarga hover-icon" onClick={this.props.getStatementDetailsForDownload} aria-hidden="true" />
                                </Link>
                              </div>
                            </div>
                          </div>
                          <VerificationPanel
                            isEmployee={this.props.isEmployee}
                            submitTransferenceData={this.props.submitTransferenceData}
                            user={this.props.user}
                            loadFrom="closureConfirmation"
                          />
                          {
                            this.props.isEmployee && this.props.isEmployee === 'true'
                            ? null
                            :
                            <div className="box-description">
                              <p style={{ fontSize: '14px' }}>
                                {commonUtil.getLabel(this.props.lables['transference success page'], 'eventTransferences.success.message')}
                                {(this.props.submitTransferenceData && this.props.submitTransferenceData.walletType !== 'undefined' && this.props.submitTransferenceData.walletType == 'Monedero Digital') &&
                                <React.Fragment>
                                  <br />
                                  {commonUtil.getLabel(this.props.lables['transference success page'], 'eventTransferences.dwallet.success.message')}
                                </React.Fragment>
                              }
                              </p>
                            </div>
                          }

                          <div className="box-instructions" style={{ width: '100%' }}>
                            <p>
                              {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label5')} &nbsp;
                              <strong>{this.props.submitData.emailAddress}</strong>, &nbsp;
                              {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label2')}
                            </p>
                            <p>
                              {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label3')}
                              <strong>
                                {commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.Para.Label4')}
                              </strong>
                            </p>
                          </div>
                          <div className="block-verification">
                            {this.props.submitData && this.props.submitData.enableSaveButton && this.props.submitData.enableSaveButton.toString() === 'true' ?
                              <div className="box-save-data row">
                                <div className="col-xs-8">
                                  <p>{commonUtil.getLabel(this.props.lables['event closure success page'], 'eventClosure.closureConfirmation.savemessage')}</p>
                                </div>
                                <div className="col-xs-4 text-right save">
                                  <InputButton buttonAttr={Guardar} />
                                </div>
                              </div> : null}
                          </div>
                          <hr />
                        </React.Fragment> : null}

                      {!_.isEmpty(this.props.submitData.closingGiftDetails) ? <ClosingGiftPanel submitTransferenceData={this.props.submitTransferenceData} printAndDownload={this.props.printAndDownload} bridgeCoreRequest={!this.props.printAndDownload ? this.props.submitData.bridgeCoreRequest : null} eventID={this.props.eventID} lables={this.props.lables} loadFrom="closureConfirmation" /> : null}
                      {!this.props.printAndDownload ?
                        <div className="row block-buttons mt10">
                          <div className="col-xs-12 text-right">
                            <InputButton buttonAttr={eventAdministrationRedirect} />
                          </div>
                        </div> : null}
                    </div>
                  </div>
                </div>
              </div>}
          </React.Fragment>
          : null}
      </div>
    );
  }
}
